import loadAwardsHandler from '../awards_handler.js?vue3';
import initDeprecatedNotes from '../init_deprecated_notes.js?vue3';
import SnippetsAppFactory from '../snippets/index.js?vue3';
import SnippetsShow from '../snippets/components/show.vue?vue3';
import ZenMode from '~/zen_mode';
import { initReportAbuse } from '../projects/report_abuse/index.js?vue3';

SnippetsAppFactory(document.getElementById('js-snippet-view'), SnippetsShow);

initDeprecatedNotes();
loadAwardsHandler();
initReportAbuse();

// eslint-disable-next-line no-new
new ZenMode();
